import { render, staticRenderFns } from "./Icon_template_331ca54c-b464-4ba7-af0f-a8157aaaed00.vue?vue&type=template&id=172afec7&"
import script from "./Icon_template_331ca54c-b464-4ba7-af0f-a8157aaaed00.vue?vue&type=script&lang=js&"
export * from "./Icon_template_331ca54c-b464-4ba7-af0f-a8157aaaed00.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports